import React, { useEffect, useRef, useState } from "react";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
  ZoomableGroup,
} from "react-simple-maps";
import { geoCentroid } from "d3-geo";
import Layout from "../../Components/Layout/Layout";
import "../LegislativeMap/LegislativeMap.css";
import MapFilters from "../../Components/LegislativeMapsComponents/MapFilters";
import MapSearch from "../../Components/LegislativeMapsComponents/MapSearch";
import MapTable from "../../Components/LegislativeMapsComponents/MapTable";
import { toast } from "react-toastify";
import { APIUrlThree, APIUrlToken } from "../../Utils/Utils";
import axios from "axios";
import Loader from "../../Components/Loader/Loader";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
import html2pdf from "html2pdf.js";
import video from "../../Assets/video.svg";
import filtericonmobile from "../../Assets/filtericonmobile.svg";
import FilterListIcon from "@mui/icons-material/FilterList";
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Tooltip,
} from "@mui/material";
import { LEGISLATIVE_MAP_VIDEO } from "../../Utils/Constants";
import TrainingModal from "../../Components/Training/TrainingModal";
import videodash from "../../Assets/play-button.png";
import MapMobileGraph from "./mapMobileGraph";
import LegislationCardMobile from "./LegislationCardMobile";
import LegisLativeFiltersMobile from "./LegisLativeFiltersMobile";

const LegislativeMap = () => {
  const [loading, setLoading] = useState(false);
  const [selectDateRange, setSelectDateRange] = React.useState("");
  const [regulationType, setRegulationType] = React.useState("");
  const [status, setStatus] = React.useState("");
  const [state, setState] = React.useState("");
  const [isCompStateSelected, setIsCompStateSelected] = React.useState("off");
  const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

  const [stateSelectedData, setStateSelectedData] = React.useState([]);
  const [statusSelectedData, setStatusSelectedData] = React.useState([]);
  const [dateRangeSelectedData, setDateRangeSelectedData] = React.useState("");
  const [regulationChangeSelectedData, setRegulationChangeSelectedData] =
    React.useState([]);
  const [headerSearchData, setheaderSearchData] = useState("");
  const [pageSize, setPageSize] = useState(0);
  const [clearRecords, setClearRecords] = useState(false);
  const [data, setData] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [videoModal, setVideoModal] = React.useState(false);
  const [stateNumbers, setStateNumbers] = useState({});
  useEffect(() => {
    localStorage.removeItem("cns");
    localStorage.removeItem("cip");
    localStorage.removeItem("cdp");
  }, []);
  let CompetitiveStatesList = [
    "Arizona",
    "California",
    "Florida",
    "Georgia",
    "Illinois",
    "Indiana",
    "Kentucky",
    "Michigan",
    "New York",
    "North Carolina",
    "Pennsylvania",
    "South Carolina",
    "Tennessee",
    "Texas",
    "Virginia",
    "West Virginia",
    "Wisconsin",
  ];

  const colorNumbers = {
    Washington: "#336699",
    Oregon: "#3399CC",
    Idaho: "#AAE1FA",
    Montana: "#3399CC",
    Wyoming: "#336699",
    California: "#6699CC",
    Nevada: "#336699",
    Utah: "#3399CC",
    Arizona: "#94BEE5",
    Colorado: "#6699CC",
    "New Mexico": "#336699",
    Texas: "#6699CC",
    Oklahoma: "#3399CC",
    Kansas: "#005996",
    Nebraska: "#3399CC",
    "South Dakota": "#6699CC",
    "North Dakota": "#336699",
    Minnesota: "#AAE1FA",
    Iowa: "#336699",
    Missouri: "#6699CC",
    Arkansas: "#336699",
    Louisiana: "#00BDF2",
    Wisconsin: "#3399CC",
    Illinois: "#7AAFDE",
    Michigan: "#336699",
    Indiana: "#6699CC",
    Kentucky: "#336699",
    Tennessee: "#00BDF2",
    Mississippi: "#3399CC",
    Alabama: "#336699",
    Georgia: "#6699CC",
    Florida: "#3399CC",
    "South Carolina": "#AAE1FA",
    "North Carolina": "#336699",
    Virginia: "#6699CC",
    Ohio: "#94BEE5",
    "West Virginia": "#3399CC",
    Maryland: "#00BDF2",
    Pennsylvania: "#336699",
    "New York": "#3399CC",
    Delaware: "#00BDF2",
    "New Jersey": "#6699CC",
    Vermont: "#00BDF2",
    "New Hampshire": "#C7EAFB",
    Maine: "#336699",
    Connecticut: "#6DCFF6",
    "Rhode Island": "#6699CC",
    Massachusetts: "#336699",
    Hawaii: "#336699",
    Alaska: "#6699CC",
  };
  const stateAbbreviations = {
    Washington: "WA",
    Oregon: "OR",
    Idaho: "ID",
    Montana: "MT",
    Wyoming: "WY",
    California: "CA",
    Nevada: "NV",
    Utah: "UT",
    Arizona: "AZ",
    Colorado: "CO",
    "New Mexico": "NM",
    Texas: "TX",
    Oklahoma: "OK",
    Kansas: "KS",
    Nebraska: "NE",
    "South Dakota": "SD",
    "North Dakota": "ND",
    Minnesota: "MN",
    Iowa: "IA",
    Missouri: "MO",
    Arkansas: "AR",
    Louisiana: "LA",
    Wisconsin: "WI",
    Illinois: "IL",
    Michigan: "MI",
    Indiana: "IN",
    Kentucky: "KY",
    Tennessee: "TN",
    Mississippi: "MS",
    Alabama: "AL",
    Georgia: "GA",
    Florida: "FL",
    "South Carolina": "SC",
    "North Carolina": "NC",
    Virginia: "VA",
    Ohio: "OH",
    "West Virginia": "WV",
    Maryland: "MD",
    Pennsylvania: "PA",
    "New York": "NY",
    Delaware: "DE",
    "New Jersey": "NJ",
    Vermont: "VT",
    "New Hampshire": "NH",
    Maine: "ME",
    Connecticut: "CT",
    "Rhode Island": "RI",
    Massachusetts: "MA",
    Hawaii: "HI",
    Alaska: "AK",
  };
  const numberStateCoordinates = [
    {
      name: "Florida",
      coord: [-81.95494968342473, 28.906457561412515],
    },
    {
      name: "Michigan",
      coord: [-85.07776779647247, 43.02043723743935],
    },
    {
      name: "Louisiana",
      coord: [-92.46015308981012, 31.041326066244075],
    },
  ];
  const StateCoordinates = {
    Alabama: [-86.2301561048623, 34.27594003320639],
    Alaska: [-147.37941922510632, 67.92441825088067],
    Arizona: [-109.66048095979119, 36.27476546518694],
    Colorado: [-102.84795634775714, 40.29725678837501],
    Florida: [-80.75494968342473, 25.906457561412515],
    Georgia: [-84.03585880538349, 34.33776705804028],
    Indiana: [-85.5816218060356, 41.09458248584918],
    Kansas: [-96.07872873001915, 39.09365521741807],
    Maine: [-69.03567170739253, 46.347668938187404],
    Massachusetts: [-71.79242034600729, 42.25426446038035],
    Minnesota: [-93.30531755931486, 47.28063805727465],
    "New Jersey": [-74.66361835510202, 40.1786081528376],
    "North Carolina": [-77.75587324336046, 35.752157015325996],
    "North Dakota": [-98.0661733975478, 48.25052672753292],
    Oklahoma: [-95.49322972355036, 36.288323039467994],
    Pennsylvania: [-76.00013468498571, 41.378280649428845],
    "South Dakota": [-98.02752309700826, 45.14450122047037],
    Texas: [-95.32049108119698, 32.96283926556849],
    Wyoming: [-105.05135765579212, 44.19566416717307],
    Connecticut: [-72.72710913374515, 41.620509452235474],
    Missouri: [-92.45786671044162, 39.85652274531175],
    "West Virginia": [-81.32506620462645, 37.63980675041306],
    Illinois: [-88.39686696689182, 41.7421155101638],
    "New Mexico": [-103.81243637126115, 36.40727151181046],
    Arkansas: [-91.24305904799438, 35.79423904686609],
    California: [-120.87292512079125, 41.183973371028706],
    Delaware: [-75.50015575692525, 38.99052700811177],
    "District of Columbia": [-77.01525985120995, 38.90376263275169],
    Hawaii: [-156.33720648961057, 20.252540261299423],
    Iowa: [-92.09572480349715, 42.875142817358035],
    Kentucky: [-83.30200559812351, 37.535023304851975],
    Maryland: [-76.75896188258156, 39.03217074868778],
    Michigan: [-84.37776779647247, 44.82043723743935],
    Mississippi: [-88.86708392107451, 34.33434137635463],
    Montana: [-104.93302925840283, 48.25246627951658],
    "New Hampshire": [-71.58044498122709, 43.67908684358301],
    "New York": [-74.50744171594333, 44.13656617324831],
    Ohio: [-81.49443033256804, 40.88894810011232],
    Oregon: [-117.56200520337184, 45.234650326315385],
    Tennessee: [-84.35095230477914, 35.858025691919615],
    Utah: [-109.87014978137779, 40.30563386025287],
    Virginia: [-78.01841247568639, 38.321267286925934],
    Wisconsin: [-88.99316336068432, 45.225848399893705],
    "American Samoa": [-170.40752127779686, -14.275944109458473],
    Guam: [144.7744692358032, 13.443702984954655],
    "Commonwealth of the Northern Mariana Islands": [
      145.61917712593282, 15.668250078664776,
    ],
    Nebraska: [-97.49454737470321, 42.03800102904538],
    "South Carolina": [-79.48970180019366, 33.70573898725427],
    "Puerto Rico": [-66.4597560864873, 18.223206170780596],
    "United States Virgin Islands": [-64.81699935521031, 18.014408555927556],
    Idaho: [-111.61267638404044, 42.350248841226914],
    Nevada: [-114.83138695435414, 41.22906900414217],
    Vermont: [-72.66662403676526, 44.068857684998626],
    Louisiana: [-91.96015308981012, 32.341326066244075],
    "Rhode Island": [-71.55242102676196, 41.67539723554143],
    Washington: [-118.128639, 48.204258],
  };
  const tooltipList = [
    "Vermont",
    "New Hampshire",
    "Massachusetts",
    "Connecticut",
    "Rhode Island",
    "New Jersey",
    "Delaware",
    "Maryland",
    "Hawaii",
  ];

  const handleApply = async (stateName, load) => {
    const resolvedStateName =
      stateName && stateName.target ? stateName.target.value : stateName;
    if (resolvedStateName) {
      setStateSelectedData([resolvedStateName]);
    }
    const selectedState = resolvedStateName
      ? [resolvedStateName]
      : stateSelectedData && stateSelectedData.length
        ? stateSelectedData
        : [];
    if (!selectedState.length && !headerSearchData.length) {
      toast.error("Please select State");
      return;
    }
    if (resolvedStateName) {
      setRegulationChangeSelectedData([]);
      setStatusSelectedData([]);
      setDateRangeSelectedData([]);
      setheaderSearchData("");
    }
    const dataStates = selectedState?.map((i) => {
      if (i === "United States") {
        return "federal";
      } else {
        return i;
      }
    });
    const dataPayload = {
      measure_type: resolvedStateName ? [] : regulationChangeSelectedData,
      state: dataStates,
      ...(dateRangeSelectedData &&
        dateRangeSelectedData.length > 0 &&
        !resolvedStateName && {
          timeframe: Array.isArray(dateRangeSelectedData)
            ? dateRangeSelectedData[0]
            : dateRangeSelectedData,
        }),
      ...(headerSearchData &&
        headerSearchData.length &&
        !resolvedStateName > 0 && {
          keyword: headerSearchData,
        }),
      status_type: resolvedStateName ? [] : statusSelectedData,
    };
    setLoading(true);
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": "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ls",
        "Content-Type": "application/json",
      },
      data: dataPayload,
      url: `${APIUrlThree()}/v1/get_legislative_tracking?skip=${load === "load" ? pageSize * 10 : 0}&limit=10`,
    };

    try {
      const response = await axios(options);
      const fetchedData = response?.data?.data || [];

      if (load === "load") {
        setData((prev) => {
          const merged = [...prev, ...fetchedData];
          return merged.sort((a, b) => {
            const dateA = new Date(a.last_update_date);
            const dateB = new Date(b.last_update_date);

            if (dateA > dateB) return -1;
            if (dateA < dateB) return 1;
            return a.title.localeCompare(b.title);
          });
        });
      } else {
        setPageSize(0);
        setData(() => {
          return [...fetchedData].sort((a, b) => {
            const dateA = new Date(a.last_update_date);
            const dateB = new Date(b.last_update_date);

            if (dateA > dateB) return -1;
            if (dateA < dateB) return 1;
            return a.title.localeCompare(b.title);
          });
        });
      }
      setDataCount(response?.data?.count);
      setClearRecords(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (pageSize !== 0) {
      handleApply("", "load");
    }
  }, [pageSize]);

  const handleLoadMore = () => {
    setPageSize((prev) => prev + 1);
  };

  const handleReset = () => {
    setClearRecords(true);
    setData([]);
    setStateSelectedData([]);
    setStatusSelectedData([]);
    setDateRangeSelectedData("");
    setRegulationChangeSelectedData([]);
    setSelectDateRange("");
    setRegulationType("");
    setStatus("");
    setState("");
    setheaderSearchData("");
    setPageSize(0);
    setDataCount(0);
  };
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const handleToPDF = () => {
    const content = componentRef.current;
    const options = {
      filename: "legislativemap.pdf",
      margin: 10,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: {
        format: "letter",
        orientation: "landscape",
      },
    };
    html2pdf().set(options).from(content).save();
  };
  const getCountMap = async () => {
    setLoading(true);
    const options = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APIUrlToken(),
        "Content-Type": "application/json",
      },
      data: data,
      url: `${APIUrlThree()}/v1/latest_legislative_count`,
    };
    axios(options)
      .then((response) => {
        const formattedData = response?.data?.data.reduce((acc, item) => {
          const stateName = item.state.replace(/\b\w/g, (char) =>
            char.toUpperCase(),
          );
          acc[stateName] = item.total_count;
          return acc;
        }, {});

        setStateNumbers(formattedData);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };
  useEffect(() => {
    getCountMap();
  }, []);

  const [zoom, setZoom] = useState(1);
  const [translate, setTranslate] = useState([0, 0]);
  const isDragging = useRef(false);
  const lastPosition = useRef([0, 0]);
  const handleZoomIn = () => setZoom((z) => Math.min(z + 0.5, 10));
  const handleZoomOut = () => setZoom((z) => Math.max(z - 0.5, 1));
  const handleMouseDown = (e) => {
    isDragging.current = true;
    lastPosition.current = [e.clientX, e.clientY];
  };
  const handleMouseMove = (e) => {
    if (!isDragging.current) return;

    const dx = (e.clientX - lastPosition.current[0]) / zoom;
    const dy = (e.clientY - lastPosition.current[1]) / zoom;

    setTranslate(([x, y]) => [x + dx, y + dy]);

    lastPosition.current = [e.clientX, e.clientY];
  };
  const handleMouseUp = () => {
    isDragging.current = false;
  };

  const handleMouseLeave = () => {
    isDragging.current = false;
  };
  const [overviewVideoModal, setOverviewVideoModal] = React.useState(false);
  const [videoLink, setVideoLink] = React.useState("");
  const handleCloseOverview = () => {
    setOverviewVideoModal(false);
  };
  const handleVideoModal = () => {
    setOverviewVideoModal(true);
    setVideoLink(LEGISLATIVE_MAP_VIDEO);
  };

  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const containerFilterRef = React.useRef(null);

  const [openFilterDrawer, setOpenFilterDrawer] = React.useState(false);
  const handleOpenFilterDrawer = () => setOpenFilterDrawer(true);
  const [openFilterDetail, setOpenFilterDetail] = React.useState("");

  const [isTabletView, setIsTabletView] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsTabletView(width >= 768 && width <= 1024);
    };

    handleResize(); // initial check
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [isPortrait, setIsPortrait] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(orientation: portrait)");

    const handleChange = (e) => {
      setIsPortrait(e.matches);
    };

    // set initial value
    setIsPortrait(mediaQuery.matches);

    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  return (
    <>
      {loading ? <Loader /> : null}
      {isMobile ? (
        <Layout>
          <div
            style={{
              padding: "68px 10px 90px 10px",
              backgroundColor: "#F3F4F9",
            }}
          >
            <p
              style={{
                fontFamily: "Inter",
                fontWeight: "700",
                fontStyle: "Bold",
                fontSize: "16px",
                padding: "0px 0px 10px 10px",
              }}
            >
              Legislation
            </p>
            <MapSearch
              handlePrint={handlePrint}
              handleToPDF={handleToPDF}
              headerSearchData={headerSearchData}
              setheaderSearchData={setheaderSearchData}
              handleApply={handleApply}
              isMobile={isMobile}
            />

            <Box
              display="flex"
              gap={2}
              sx={{
                py: 2,
                bgcolor: "#F3F4F9",
              }}
              ref={containerFilterRef}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#fff",
                  padding: "5px 10px",
                  borderRadius: "5px",
                  gap: "5px",
                }}
                onClick={handleOpenFilterDrawer}
              >
                <img src={filtericonmobile} alt="" />
                <p
                  style={{
                    fontFamily: "Inter",
                    fontWeight: "500",
                    fontStyle: "Medium",
                    fontSize: "14px",
                    color: "#6B7280",
                  }}
                >
                  Filters
                </p>
              </div>
              <div></div>
            </Box>
            <MapMobileGraph
              stateAbbreviations={stateAbbreviations}
              stateSelectedData={stateSelectedData}
              setStateSelectedData={setStateSelectedData}
              state={state}
              setState={setState}
              handleApply={handleApply}
              handleReset={handleReset}
            />
            {dataCount ? (
              <p
                className={
                  clearRecords
                    ? "showing-legislative-count-hide"
                    : "showing-legislative-count"
                }
              >
                Showing {dataCount} Records
              </p>
            ) : (
              <p
                style={{
                  textAlign: "center",
                  paddingBottom: "10px",
                  fontSize: "14px",
                }}
              >
                Please adjust filters to view results
              </p>
            )}
            <LegislationCardMobile
              data={data}
              dataCount={dataCount}
              pageSize={pageSize}
              regulationType={regulationType}
              handleLoadMore={handleLoadMore}
            />
          </div>
          <LegisLativeFiltersMobile
            openFilterDrawer={openFilterDrawer}
            setOpenFilterDrawer={setOpenFilterDrawer}
            setOpenFilterDetail={setOpenFilterDetail}
            openFilterDetail={openFilterDetail}
            ResetFilterData={handleReset}
            stateSelectedData={stateSelectedData}
            setStateSelectedData={setStateSelectedData}
            statusSelectedData={statusSelectedData}
            setStatusSelectedData={setStatusSelectedData}
            dateRangeSelectedData={dateRangeSelectedData}
            setDateRangeSelectedData={setDateRangeSelectedData}
            regulationChangeSelectedData={regulationChangeSelectedData}
            setRegulationChangeSelectedData={setRegulationChangeSelectedData}
            selectDateRange={selectDateRange}
            setSelectDateRange={setSelectDateRange}
            regulationType={regulationType}
            setRegulationType={setRegulationType}
            status={status}
            setStatus={setStatus}
            state={state}
            setState={setState}
            handleApply={handleApply}
          />
        </Layout>
      ) : isPortrait ? (
        <Layout>
          <div
            style={{
              padding: "10px",
              backgroundColor: "#F3F4F9",
            }}
          >
            <p
              style={{
                fontFamily: "Inter",
                fontWeight: "700",
                fontStyle: "Bold",
                fontSize: "16px",
                padding: "0px 0px 10px 10px",
              }}
            >
              US Legislative Map
            </p>
              <p className="legislative-map-content">
                Use our interactive map to monitor legislation across each US
                State. Each State has the number of Year-to-Date legislative
                articles. Simply click on the State to view legislative details.
              </p>
            <MapSearch
              handlePrint={handlePrint}
              handleToPDF={handleToPDF}
              headerSearchData={headerSearchData}
              setheaderSearchData={setheaderSearchData}
              handleApply={handleApply}
              isMobile={isMobile}
            />

            <MapFilters
              stateSelectedData={stateSelectedData}
              setStateSelectedData={setStateSelectedData}
              statusSelectedData={statusSelectedData}
              setStatusSelectedData={setStatusSelectedData}
              dateRangeSelectedData={dateRangeSelectedData}
              setDateRangeSelectedData={setDateRangeSelectedData}
              regulationChangeSelectedData={regulationChangeSelectedData}
              setRegulationChangeSelectedData={setRegulationChangeSelectedData}
              selectDateRange={selectDateRange}
              setSelectDateRange={setSelectDateRange}
              regulationType={regulationType}
              setRegulationType={setRegulationType}
              status={status}
              setStatus={setStatus}
              state={state}
              setState={setState}
              handleApply={handleApply}
              handleReset={handleReset}
            />
            <MapMobileGraph
            isPortrait={isPortrait}
              stateAbbreviations={stateAbbreviations}
              stateSelectedData={stateSelectedData}
              setStateSelectedData={setStateSelectedData}
              state={state}
              setState={setState}
              handleApply={handleApply}
              handleReset={handleReset}
            />
            {dataCount ? (
              <p
                className={
                  clearRecords
                    ? "showing-legislative-count-hide"
                    : "showing-legislative-count"
                }
              >
                Showing {dataCount} Records
              </p>
            ) : (
              <p
                style={{
                  textAlign: "center",
                  paddingBottom: "10px",
                  fontSize: "14px",
                }}
              >
                Please adjust filters to view results
              </p>
            )}
            <LegislationCardMobile
              data={data}
              dataCount={dataCount}
              pageSize={pageSize}
              regulationType={regulationType}
              handleLoadMore={handleLoadMore}
            />
          </div>
          <LegisLativeFiltersMobile
            openFilterDrawer={openFilterDrawer}
            setOpenFilterDrawer={setOpenFilterDrawer}
            setOpenFilterDetail={setOpenFilterDetail}
            openFilterDetail={openFilterDetail}
            ResetFilterData={handleReset}
            stateSelectedData={stateSelectedData}
            setStateSelectedData={setStateSelectedData}
            statusSelectedData={statusSelectedData}
            setStatusSelectedData={setStatusSelectedData}
            dateRangeSelectedData={dateRangeSelectedData}
            setDateRangeSelectedData={setDateRangeSelectedData}
            regulationChangeSelectedData={regulationChangeSelectedData}
            setRegulationChangeSelectedData={setRegulationChangeSelectedData}
            selectDateRange={selectDateRange}
            setSelectDateRange={setSelectDateRange}
            regulationType={regulationType}
            setRegulationType={setRegulationType}
            status={status}
            setStatus={setStatus}
            state={state}
            setState={setState}
            handleApply={handleApply}
          />
        </Layout>
      ) : (
        // (
        //   <Layout>
        //     <div>
        //       <p
        //         style={{
        //           fontFamily: "Inter",
        //           fontWeight: "700",
        //           fontStyle: "Bold",
        //           fontSize: "20px",
        //           padding: "20px",
        //         }}
        //       >
        //         US Legislative Map
        //       </p>
        //     </div>
        //   </Layout>
        // )
        <Layout>
          <div>
            <div className="lg-map-main-container">
              <div className="heading-vdio-lmap">
                <p className="legislative-map-head">US Legislative Map</p>
                <div
                  className="video_container"
                  onClick={() => setVideoModal(!videoModal)}
                >
                  <img src={video} alt="video" className="videoIcon" />
                  {videoModal && (
                    <div className="bell-icon-box-video">
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal()}
                      >
                        <div className="bell-icon-outer-video">
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Legislative Map</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <p className="legislative-map-content">
                Use our interactive map to monitor legislation across each US
                State. Each State has the number of Year-to-Date legislative
                articles. Simply click on the State to view legislative details.
              </p>
              <div className="lg-map-filter-cont-st">
                <div className="radio-input-track">
                  <div>
                    {" "}
                    <p>Competitive States</p>
                  </div>

                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      className="rg-direct-paths"
                      onChange={(e) => setIsCompStateSelected(e?.target?.value)}
                    >
                      <FormControlLabel
                        className="direct-path-track"
                        checked={isCompStateSelected === "off"}
                        value="off"
                        control={<Radio />}
                        label="Off"
                      />
                      <FormControlLabel
                        className={"direct-path-track"}
                        checked={isCompStateSelected === "on"}
                        value="on"
                        control={<Radio />}
                        label="On"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>
              <div
                style={{ position: "relative", width: "100%", cursor: "grab" }}
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseLeave}
              >
                <div className="map-buttons-lagislative">
                  <button onClick={handleZoomIn}>+</button>
                  <button onClick={handleZoomOut}>-</button>
                </div>

                <ComposableMap
                  projection="geoAlbersUsa"
                  width={1000}
                  height={500}
                >
                  <g
                    transform={`translate(${translate[0]}, ${translate[1]}) scale(${zoom})`}
                  >
                    <Geographies geography={geoUrl}>
                      {({ geographies }) => {
                        const filteredGeographies =
                          isCompStateSelected === "on"
                            ? geographies.filter((geo) =>
                                CompetitiveStatesList.includes(
                                  geo.properties.name,
                                ),
                              )
                            : geographies;

                        return filteredGeographies.map((geo) => {
                          const stateName = geo.properties.name;
                          let centroid = geoCentroid(geo);
                          let state = numberStateCoordinates?.find(
                            (i) => i.name === stateName,
                          );
                          if (state) {
                            centroid = state?.coord;
                          }
                          const stateNumber = stateNumbers[stateName] || "";
                          const color = colorNumbers[stateName];
                          const abbreviation = stateAbbreviations[stateName];
                          const coordinate = StateCoordinates[stateName];
                          const tooltipexist = tooltipList?.some(
                            (i) => i === stateName,
                          );
                          return (
                            <>
                              {tooltipexist ? (
                                <Tooltip
                                  placement="top"
                                  title={
                                    <div
                                      style={{
                                        padding: "8px 12px",
                                        maxWidth: 200,
                                      }}
                                    >
                                      <div
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: 14,
                                        }}
                                      >
                                        <span style={{ fontWeight: "normal" }}>
                                          {stateName}, {abbreviation}
                                        </span>
                                      </div>
                                      <div
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: 14,
                                        }}
                                      >
                                        Measure Count:{" "}
                                        <span style={{ fontWeight: "normal" }}>
                                          {stateNumber}
                                        </span>
                                      </div>
                                    </div>
                                  }
                                  PopperProps={{
                                    modifiers: [
                                      {
                                        name: "offset",
                                        options: {
                                          offset: [0, -10],
                                        },
                                      },
                                    ],
                                  }}
                                  componentsProps={{
                                    tooltip: {
                                      sx: {
                                        backgroundColor: "#FFFFFF",
                                        color: "#333",
                                        boxShadow:
                                          "0 4px 12px rgba(0,0,0,0.15)",
                                        borderRadius: "8px",
                                        fontSize: "14px",
                                        fontFamily: "Arial",
                                      },
                                    },
                                  }}
                                >
                                  <g key={geo.rsmKey}>
                                    <Geography
                                      geography={geo}
                                      onClick={() => handleApply(stateName)}
                                      style={{
                                        default: {
                                          fill: color || "#fff",
                                          stroke: "#fff",
                                          strokeWidth: 2,
                                          outline: "none",
                                        },
                                        hover: {
                                          fill: "#3399CC",
                                          outline: "none",
                                        },
                                        pressed: {
                                          fill: "#3399CC",
                                          outline: "none",
                                        },
                                      }}
                                    />
                                  </g>
                                </Tooltip>
                              ) : (
                                <g key={geo.rsmKey}>
                                  <Geography
                                    geography={geo}
                                    onClick={() => handleApply(stateName)}
                                    style={{
                                      default: {
                                        fill: color || "#fff",
                                        stroke: "#fff",
                                        strokeWidth: 2,
                                        outline: "none",
                                      },
                                      hover: {
                                        fill: "#3399CC",
                                        outline: "none",
                                      },
                                      pressed: {
                                        fill: "#3399CC",
                                        outline: "none",
                                      },
                                    }}
                                  />
                                  {stateNumber &&
                                    centroid[0] &&
                                    centroid[1] && (
                                      <Marker coordinates={centroid}>
                                        <text
                                          onClick={() => handleApply(stateName)}
                                          textAnchor="middle"
                                          style={{
                                            fontFamily: "Arial",
                                            fontSize: 15,
                                            fill: "#fff",
                                            stroke: "#000",
                                            strokeWidth: 0.5,
                                            fontWeight: 700,
                                          }}
                                        >
                                          {stateNumber}
                                        </text>
                                      </Marker>
                                    )}
                                  {abbreviation &&
                                    coordinate[0] &&
                                    coordinate[1] && (
                                      <Marker coordinates={coordinate}>
                                        <text
                                          onClick={() => handleApply(stateName)}
                                          textAnchor="middle"
                                          style={{
                                            fontFamily: "Arial",
                                            fontSize: 13,
                                            fill: "#ffffff63",
                                            fontWeight: 600,
                                          }}
                                        >
                                          {abbreviation}
                                        </text>
                                      </Marker>
                                    )}
                                </g>
                              )}
                            </>
                          );
                        });
                      }}
                    </Geographies>
                  </g>
                </ComposableMap>
              </div>
            </div>

            <div className="map-filters">
              <MapSearch
                handlePrint={handlePrint}
                handleToPDF={handleToPDF}
                headerSearchData={headerSearchData}
                setheaderSearchData={setheaderSearchData}
                handleApply={handleApply}
              />
              <MapFilters
                stateSelectedData={stateSelectedData}
                setStateSelectedData={setStateSelectedData}
                statusSelectedData={statusSelectedData}
                setStatusSelectedData={setStatusSelectedData}
                dateRangeSelectedData={dateRangeSelectedData}
                setDateRangeSelectedData={setDateRangeSelectedData}
                regulationChangeSelectedData={regulationChangeSelectedData}
                setRegulationChangeSelectedData={
                  setRegulationChangeSelectedData
                }
                selectDateRange={selectDateRange}
                setSelectDateRange={setSelectDateRange}
                regulationType={regulationType}
                setRegulationType={setRegulationType}
                status={status}
                setStatus={setStatus}
                state={state}
                setState={setState}
                handleApply={handleApply}
                handleReset={handleReset}
              />
              {dataCount ? (
                <p
                  className={
                    clearRecords
                      ? "showing-legislative-count-hide"
                      : "showing-legislative-count"
                  }
                >
                  Showing {dataCount} Records
                </p>
              ) : null}
              <div ref={componentRef}>
                <MapTable
                  data={data}
                  dataCount={dataCount}
                  pageSize={pageSize}
                  regulationType={regulationType}
                  handleLoadMore={handleLoadMore}
                />
              </div>
            </div>
          </div>
          <TrainingModal
            overviewVideoModal={overviewVideoModal}
            handleCloseOverview={handleCloseOverview}
            videoLink={videoLink}
          />
        </Layout>
      )}
    </>
  );
};
export default LegislativeMap;
